
export default function Title({ title, icon }) {
    return (
        <div className="admin-page-title w-full flex items-center gap-3">
            <h3 className="text-xl font-semibold text-slate-800 dark:text-slate-100">{title || null}</h3>
            {icon || null}
        </div>
    )
}
